module.exports = __webpack_public_path__ + "img/damnnlogo2.d07e860a.png";